<template>
	<router-view />
</template>

<script>

export default {
	name: "report_root",
}
</script>

<style scoped></style>